import { DatePicker, Radio, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React, { useState } from 'react';

const TimeDatePicker = ({ onChange, isHideRange }: { onChange: (value: { metricsType: string; startTime: number; endTime: number }) => void; isHideRange?: boolean }) => {
  const [value, setValue] = useState('1h');
  const [dates, setDates] = useState<[Dayjs, Dayjs]>([dayjs().subtract(1, 'hour'), dayjs()]);

  const onChangeValues = ({ value, times }: { value: string; times: [Dayjs, Dayjs] }) => {
    setValue(value);
    setDates(times);
    onChange({ metricsType: value, startTime: times[0].valueOf(), endTime: times[1].valueOf() });
  };
  return (
    <Space size={24}>
      <Radio.Group
        options={[
          { label: '最近一小时', value: '1h' },
          { label: '最近24小时', value: '24h' },
          { label: '近一周', value: '1week' },
        ]}
        onChange={({ target: { value: type } }) => {
          const times: [Dayjs, Dayjs] = type === '1h' ? [dayjs().subtract(1, 'hour'), dayjs()] : type === '24h' ? [dayjs().subtract(24, 'hour'), dayjs()] : [dayjs().subtract(1, 'week'), dayjs()];
          onChangeValues({ value: type, times });
        }}
        value={value}
        optionType="button"
        buttonStyle="solid"
      />
      {!isHideRange && (
        <DatePicker.RangePicker
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          value={dates}
          onChange={(v) => {
            onChangeValues({ value: '', times: v as [Dayjs, Dayjs] });
          }}
        />
      )}
    </Space>
  );
};

export default TimeDatePicker;
